import React, { Component } from 'react';
import { Container, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import CV from '../files/Ersoy_Efe_Uruk_CV.pdf';

export default class WorkExperience extends Component {
    render() {
        return (
            <section className="workExperience" id="work-experience">
                <Container>
                    <h1>Work Experience</h1>
                    <p>I have worked in different companies. Mostly worked on
                    Web Applications. Here is the CV of mine to inform you about me: </p>
                    <Button
                        style={{ fontSize: "calc(10px + 1vmin)" }}
                        href={CV}
                        target="_blank" 
                        rel="noopener noreferrer">
                        Download My CV <FontAwesomeIcon icon={faDownload} />
                    </Button>
                </Container>
            </section>
        )
    }
}
